import React, { useState } from "react";
import "./MyEntriesDisplay.css";
import { graphql, useLazyLoadQuery } from "react-relay";
import Select, { createFilter, components } from "react-select";
import AsyncSelect from "react-select/async";
import ReactSelectList from "../../../../../ReactSelectList";
import Top500ListDisplay from "../Top500ListDisplay";
import PGASweatsSummarySection from "../PGASweatsSummarySection";

const QUERY = graphql`
  query MyEntriesDisplayQuery($contestId: ID!) {
    entrantsForContest(contestId: $contestId) {
      id
      username
    }
  }
`;

export default function MyEntriesDisplay({ contestId }) {
  const queryData = useLazyLoadQuery(
    QUERY,
    { contestId: contestId },
    { fetchPolicy: "network-only" }
  );
  const [selectedOptionId, setSelectedOptionId] = useState(undefined);

  const selectOptions = React.useMemo(() => {
    return queryData.entrantsForContest.map((entrant) => {
      return { value: entrant.id, label: entrant.username };
    });
  }, [queryData]);

  const MenuList = ({ children, ...props }) => {
    return (
      <components.MenuList {...props}>
        {
          Array.isArray(children)
            ? children.slice(0, props.selectProps?.maxOptions) /* Options */
            : children /* NoOptionsLabel */
        }
      </components.MenuList>
    );
  };

  return (
    <div>
      <p>
        <div style={{ position: "relative", zIndex: "9999" }}>
          <strong>Search Contest Entrant</strong>

          <Select
            id="sport-select"
            options={selectOptions}
            onChange={(selected) => {
              setSelectedOptionId(selected.value);
            }}
            filterOption={createFilter({ ignoreAccents: false })}
            components={{ MenuList }}
            maxOptions={10}
          />
        </div>
        <br />

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          <React.Suspense fallback={"Loading data..."}>
            {selectedOptionId ? (
              <PGASweatsSummarySection
                contestId={contestId}
                playerId={selectedOptionId}
                graphWidth={"49%"}
              />
            ) : null}
          </React.Suspense>
        </div>

        <React.Suspense fallback={"Loading data..."}>
          {selectedOptionId ? (
            <Top500ListDisplay
              contestId={contestId}
              playerId={selectedOptionId}
            />
          ) : null}
        </React.Suspense>
      </p>
    </div>
  );
}
